export default class Message {
  constructor(
    id,
    chatId,
    senderId,
    senderName,
    recipientId,
    text,
    sendDate,
    wasRead,
    isDeleted,
    imageUrl,
    messageType,
    attachmentUrl,
    attachmentName,
    attachmentMimeType,
    attachmentSize,
    storagePath,
    replyTo = null
  ) {
    this.id = id;
    this.chatId = chatId;
    this.senderId = senderId;
    this.senderName = senderName;
    this.recipientId = recipientId;
    this.text = text;
    this.sendDate = sendDate;
    this.wasRead = wasRead;
    this.isDeleted = isDeleted;
    this.imageUrl = imageUrl;

    this.messageType = messageType;
    this.attachmentUrl = attachmentUrl;
    this.attachmentName = attachmentName;
    this.attachmentMimeType = attachmentMimeType;
    this.attachmentSize = attachmentSize;
    this.storagePath = storagePath;

    this.replyTo = Message.normalizeReply(
      replyTo
    );
  }

  static normalizeReply(reply) {
    if (!reply) return null;

    return {
      messageId:
        reply.messageId ||
        reply.message_id ||
        "",

      senderId:
        reply.senderId ||
        reply.sender_id ||
        "",

      senderName:
        reply.senderName ||
        reply.sender_name ||
        "Пользователь",

      text:
        reply.text ??
        reply.text_message ??
        null,

      imageUrl:
        reply.imageUrl ||
        reply.image_url ||
        null,

      attachmentName:
        reply.attachmentName ||
        reply.attachment_name ||
        null,

      messageType:
        reply.messageType ||
        reply.message_type ||
        "text"
    };
  }

  static fromJson(json) {
    if (!json) return null;

    return new Message(
      json.message_id || json.id,
      json.chat_id || json.id,
      json.sender_id,
      json.sender_name,
      json.recipient_id,
      json.text_message ?? json.text ?? "",
      json.send_date,
      json.was_read ?? json.is_read ?? false,
      json.is_deleted ?? false,
      json.image_url ?? null,

      json.message_type ?? null,
      json.attachment_url ?? null,
      json.attachment_name ?? null,
      json.attachment_mime_type ?? null,
      json.attachment_size ?? null,
      json.storage_path ?? null,

      json.reply_to ?? json.replyTo ?? null
    );
  }

  get hasText() {
    return Boolean(
      this.text &&
      this.text.trim()
    );
  }

  get isImage() {
    return Boolean(this.imageUrl);
  }

  get isFile() {
    return Boolean(
      this.attachmentUrl &&
      !this.imageUrl
    );
  }

  get previewText() {
    if (this.hasText) {
      return this.text;
    }

    if (this.isImage) {
      return "📷 Фото";
    }

    if (this.attachmentName) {
      return `📎 ${this.attachmentName}`;
    }

    if (this.attachmentUrl) {
      return "📎 Файл";
    }

    return "Нет сообщений";
  }
}